import { SUCCESS_SUFFIX, FAILURE_SUFFIX } from 'core/actions/apis';

const rootActionPath = 'core/personalizedTopOffers';

export const PERSONALIZED_TOP_OFFERS_GET_SUCCESS = `${rootActionPath}/GET_${SUCCESS_SUFFIX}`;
export const PERSONALIZED_TOP_OFFERS_GET_FAILURE = `${rootActionPath}/GET_${FAILURE_SUFFIX}`;

export const PERSONALIZED_TOP_OFFERS_VIEW = `${rootActionPath}/VIEW`;
